module.exports = __webpack_public_path__ + "img/home_page_three_side_bg.538ad20b.png";